import 'lib/pages-common'
import GlideSliderController from 'controllers/glide-slider-controller'
import 'cities/parallax_steps_component/parallax_steps_component_preview'

application.register('glide-slider', GlideSliderController)
